














import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import { formatMoney } from "@/utils/utils";
import { PaymentIntentStatus } from "@/enums/paymentIntent.enum";
import { mapGetters } from "vuex";

export default Vue.extend({
  name: "PaymentStatusChip",
  props: {
    paymentId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      payment: {} as any,
    };
  },
  created() {
    this.payment = this.getPaymentIntents.filter(
      (pi: any) => pi.id === this.paymentId
    )[0];
  },
  computed: {
    ...mapGetters("paymentIntent", ["getPaymentIntents"]),
    amountRefunded(): number {
      return this.payment?.charges?.data[0]?.amount_refunded || 0;
    },
    customStatus(): string {
      if (this.payment.last_payment_error !== null) {
        return PaymentIntentStatus.FAILED;
      } else if (this.payment.status === PaymentIntentStatus.CANCELED) {
        return this.payment.status;
      } else {
        const refundStatus =
          this.amountRefunded && this.amountRefunded === this.payment.amount
            ? PaymentIntentStatus.FULL_REFUND
            : PaymentIntentStatus.PARTIAL_REFUND;
        return this.amountRefunded ? refundStatus : this.payment.status;
      }
    },
    label(): TranslateResult {
      return this.customStatus
        ? this.$t(`payment.status.${this.customStatus}.label`)
        : "";
    },
    icon(): TranslateResult {
      return this.customStatus
        ? this.$t(`payment.status.${this.customStatus}.icon`)
        : "";
    },
    color(): TranslateResult {
      return this.customStatus
        ? this.$t(`payment.status.${this.customStatus}.color`)
        : "";
    },
    textColor(): TranslateResult {
      return this.customStatus
        ? this.$t(`payment.status.${this.customStatus}.textColor`)
        : "";
    },
    hint(): TranslateResult {
      if (!this.customStatus) {
        return "";
      }

      if (this.payment.last_payment_error) {
        return this.payment.last_payment_error.message;
      }

      const params = [];
      if (this.payment.cancellation_reason) {
        params.push(
          this.$t(
            `payment.status.${this.customStatus}.reason.${this.payment.cancellation_reason}`
          )
        );
      } else if (
        this.amountRefunded > 0 &&
        this.customStatus !== PaymentIntentStatus.CANCELED
      ) {
        params.push(
          formatMoney({
            amount: this.amountRefunded,
            currency: this.payment.currency,
          })
        );
      }
      return this.$t(`payment.status.${this.customStatus}.hint`, [params]);
    },
  },
});
